import { AppConfig } from '../types';

const eltimexConfig: Partial<AppConfig> = {
  company: {
    name: 'Eltimex',
    logo: '/logo512.png',
    slogan: 'Specjaliści w branży elektro-energetycznej',
    about: {
      shortInfo: `Jesteśmy hurtownią elektryczną
          z wieloletnim doświadczeniem, która stawia na jakość, niezawodność i
          profesjonalną obsługę. Nasz katalog obejmuje szeroki asortyment
          produktów elektrycznych - od kabli, przewodów, osprzętu
          instalacyjnego, po oświetlenie i nowoczesne technologie.`,
      longInfo: [
        {
          section: `Eltimex to hurtownia elektryczna z wieloletnim doświadczeniem,
                która stawia na jakość, niezawodność i profesjonalną obsługę.
                Specjalizujemy się w dostarczaniu kompleksowych rozwiązań dla
                branży elektrycznej i energetycznej.`,
        },
        {
          section: `Nasz katalog obejmuje szeroki asortyment produktów elektrycznych
                - od kabli, przewodów, osprzętu instalacyjnego, po oświetlenie i
                nowoczesne technologie. Współpracujemy z najlepszymi
                producentami w branży, aby zapewnić naszym klientom produkty
                najwyższej jakości.`,
        },
        {
          section: `Dzięki wieloletniemu doświadczeniu i fachowej wiedzy naszego
                zespołu, możemy doradzić i pomóc w doborze odpowiednich
                rozwiązań dla każdego projektu, niezależnie od jego skali i
                stopnia skomplikowania.`,
        },
      ],
    },
    history: [
      {
        year: '1996',
        title: 'Założenie firmy',
        description:
          'Firma Eltimex rozpoczęła działalność jako lokalny dystrybutor osprzętu elektrycznego.',
      },
      {
        year: '2005',
        title: 'Rozszerzenie działalności',
        description:
          'Rozszerzyliśmy ofertę o kompleksowe rozwiązania dla branży elektrycznej i energetycznej.',
      },
      {
        year: '2015',
        title: 'Nowa siedziba',
        description:
          'Przeprowadziliśmy się do nowej, większej siedziby z nowoczesnym magazynem i ekspozycją produktów.',
      },
      {
        year: '2025',
        title: 'Sklep internetowy',
        description:
          'Uruchomiliśmy sklep internetowy, aby zapewnić łatwiejszy dostęp do naszych produktów dla klientów z całej Polski.',
      },
    ],
    founded: '1996',
  },
  contact: {
    email: 'kontakt@eltimex.pl',
    phone: '+48 604 856 094',
    address: {
      street: 'ul. Nadrzeczna 1',
      postal: '42-360',
      city: 'Poraj',
      region: 'śląskie',
      country: 'Polska',
    },
    googleMaps:
      'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d5055.974572255216!2d19.203013!3d50.683061!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47173480d66e46b5%3A0x2991caf494319d7f!2sEltimex!5e0!3m2!1spl!2spl!4v1740353448025!5m2!1spl!2spl',
  },
  social: {
    facebook: 'https://www.facebook.com/profile.php?id=61568154016316',
    instagram: 'https://www.instagram.com/eltimexx/',
    youtube: 'https://www.youtube.com/@Eltimexx',
    google: 'https://g.co/kgs/UP69KkN',
  },
  theme: {
    fontFamily: 'Inter, system-ui, sans-serif',
    colors: {
      primary: '#003566',
      secondary: '#e6b000',
      accent: '#ffd60a',
      background: '#001d3d',
      text: '#000814',
    },
    mainColor: 'blue',
  },
  banners: {
    home: [
      {
        id: 1,
        image: 'images/main-page-background-2.jpg',
        title: 'Kompleksowe rozwiązania elektryczne',
        subtitle:
          'Od 2002 roku dostarczamy najwyższej jakości produkty elektryczne',
        cta: {
          text: 'Zobacz ofertę',
          link: '/szukaj',
        },
        position: 'left',
      },
      {
        id: 2,
        image: 'images/main-page-background-1.jpg',
        title: 'Profesjonalne produkty dla wymagających',
        subtitle:
          'Szeroki wybór urządzeń i komponentów od renomowanych producentów',
        cta: {
          text: 'Sprawdź bestsellery',
          link: '/szukaj?tag=Bestseller',
        },
        position: 'right',
      },
    ],
  },
  ui: {
    navbar: {
      showCategoriesOnHomepage: true,
    },
  },
  meta: {
    keywords: [
      'eltimex',
      'hurtownia elektryczna',
      'elektryka',
      'elektrotechnika',
      'kable',
      'przewody',
      'osprzęt elektryczny',
      'oświetlenie',
      'technologie elektryczne',
      'komponenty elektryczne',
      'instalacje elektryczne',
      'elektronika',
      'automatyka',
    ],
    description:
      'Eltimex to hurtownia elektryczna z wieloletnim doświadczeniem, oferująca szeroki asortyment produktów elektrycznych, od kabli po nowoczesne technologie. Specjalizujemy się w dostarczaniu kompleksowych rozwiązań dla branży elektrycznej i energetycznej.',
  },
};

export default eltimexConfig;
